<template>
<header
	class="header"
	:class="{
      'header--active': active,
      'header--fixed': fixed,
      'header--show': show,
      'header--hide': hide
    }"
>
	<button
		v-if="$route.path !== '/'"
		class="header__toggle"
		@click="() => active = !active"
	>
		<span
			v-if="!active"
			class="header__toggle-open"
		> Menu </span>
		<span
			v-if="active"
			class="header__toggle-close"
		> Close </span>
	</button>
	<p
		v-if="$route.meta.showTitle"
		class="header__title"
		v-html="$route.name"
	></p>
	<Navigation
		:active="active"
		@toggle="resetHeader"
	/>
	<router-link
		class="header__home"
		to="/"
	>
		<span>J. W</span>
	</router-link>
</header>
</template>

<script>
import Navigation from '@/components/Navigation'
export default {
	name: 'AppHeader',
	components: {
		Navigation
	},
	data() {
		return {
			active: false,
			fixed: true,
			show: true,
			hide: false,
			top: 0,
			scrollInterval: false
		}
	},
	watch: {
		'$route': {
			handler(route) {
				window.scrollTo(0, 0)
				setTimeout(() => {
					this.resetHeader()
				}, 200)
			}
		}
	},
	mounted() {
		window.addEventListener('scroll', () => {
			if (window.scrollY >= 400) {
				if (this.top > window.scrollY) {
					this.hide = false
					this.show = true
				} else {
					this.hide = true
					this.show = false
				}
				this.fixed = true
			} else {
				this.hide = false
				this.show = true
			}
			this.top = window.scrollY
		})
	},
	methods: {
		resetHeader() {
			this.active = false
			this.show = true
			this.hide = false
		}
	}
}
</script>

<style lang="scss" scoped>
.header {
	width: 100%;
	padding: $site-padding $site-padding-lrg #{$site-padding / 2.5} $site-padding-lrg;
	align-self: flex-start;
	position: absolute;
	left: 0px;
	top: 0px;
	z-index: 100;

	&--fixed {
		position: fixed;
		transition: top 240ms ease-in-out;
	}

	&--show {
		top: 0px;
		transition: top 360ms ease-in-out;
	}

	&--hide {
		top: -200px;
	}

	&--active {
		position: fixed;
		height: 100vh;

		&:after {
			content: '';
			background: $brown;
			width: 100%;
			height: 100vh;
			display: inline-block;
			position: absolute;
			top: 0px;
			left: 0px;
			z-index: -1;
		}

		.header__nav {
			visibility: visible;
			opacity: 1;
			transition-delay: 100ms;
			position: fixed;
			width: calc(100% - #{$site-padding-lrg * 2});
			top: 50%;
			transform: translateY(-50%);
		}

		.header__toggle {
			&:hover {
				// opacity: 1;
				// color: white !important;
			}
		}
	}

	&__toggle {
		@include button_resets;
		font-size: $body;
		font-family: $maison;
		line-height: 31px;
		cursor: pointer;
		color: #000;
		transition: opacity 200ms ease-in-out, color 200ms ease-in-out;

		span {
			line-height: 1;
			margin: 0 10px 0 0;
			position: relative;
			opacity: 1;
			pointer-events: none;
		}

		&:hover {
			opacity: 0.65;
		}
	}

	&__title {
		top: $site-padding;
		position: absolute;
		margin: 0 auto 0 15%;
		max-width: 1400px;
		font-family: $maison;
		z-index: -1;
	}

	&__home {
		position: absolute;
		right: $site-padding-lrg;
		top: $site-padding;
		font-family: $maison;
		font-size: calc(#{$heading} - 2px);
		line-height: $line-height;
		letter-spacing: 2px;
		line-height: 1;
		transform: translateY(-3px);
		transition: opacity 200ms ease-in-out;
		background-image: url('/images/JW_Wordmark.svg');
		background-size: contain;
		background-position: center;
		background-repeat: no-repeat;

		span {
			opacity: 0;
		}

		&:hover {
			opacity: 0.65;
		}
	}

	@include mobile {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		padding: $site-padding--m $mobile-padding;

		&__home {
			font-size: $heading--m;
			top: calc(#{$site-padding--m} + 2px);
			right: $mobile-padding;
			line-height: 0.95;
			transform: unset;
		}

		&__title {
			display: none;
		}
	}
}
</style>
